"use client";

export default function PiSummary({
  isDetailsVisible,
  isReady,
  totalText,
  baseText,
  safeFeePercent,
  priceUSDNum,
}) {
  const fmtUSD = (n) =>
    Number.isFinite(n)
      ? new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: "USD",
        }).format(n)
      : null;

  return (
    <div className="mt-3 min-h-[56px]">
      {!isDetailsVisible ? (
        <p className="text-sm text-textPrimary">Tap to see details…</p>
      ) : isReady ? (
        <>
          <div className="text-lg font-semibold text-primary">🪙 {totalText} Pi</div>
          <p className="text-xs text-textPrimary">
            Base: {baseText} Pi + Fee: {safeFeePercent}%
          </p>
          {priceUSDNum != null && (
            <p className="text-xs text-textPrimary">≈ {fmtUSD(priceUSDNum)} USD</p>
          )}
        </>
      ) : (
        <p className="text-sm text-textPrimary">Calculating…</p>
      )}
    </div>
  );
}